import { Check, X, Minus } from "lucide-react";
import { ScrollReveal } from "../ui/ScrollReveal";
import { COMPARISON_ROWS } from "../../data/content";

const Cell = ({ value, highlight }) => (
  <td className={`px-4 py-4 text-xs sm:text-sm ${highlight ? "text-cyan-300 font-semibold" : "text-slate-400"}`}>
    {value}
  </td>
);

export const ComparisonTable = () => {
  return (
    <section className="relative bg-[#020617] py-24 sm:py-32 px-5 sm:px-8" data-testid="comparison-section">
      <div className="max-w-6xl mx-auto">
        <ScrollReveal>
          <span className="font-mono-brand text-xs uppercase tracking-[0.25em] text-cyan-400">Why Choose Active360™</span>
          <h2 className="font-display font-extrabold uppercase text-2xl sm:text-3xl lg:text-4xl text-white mt-4">
            One Platform. Every Comparison Wins.
          </h2>
        </ScrollReveal>

        <ScrollReveal delay={0.15} className="mt-12 overflow-x-auto glass-card rounded-2xl">
          <table className="w-full min-w-[640px]" data-testid="comparison-table">
            <thead>
              <tr className="border-b border-slate-800">
                <th className="px-4 py-4 text-left text-xs font-mono-brand uppercase tracking-widest text-slate-500">Feature</th>
                <th className="px-4 py-4 text-left text-xs font-mono-brand uppercase tracking-widest text-cyan-400">Active360™</th>
                <th className="px-4 py-4 text-left text-xs font-mono-brand uppercase tracking-widest text-slate-500">Personal Trainer</th>
                <th className="px-4 py-4 text-left text-xs font-mono-brand uppercase tracking-widest text-slate-500">Generic Fitness App</th>
              </tr>
            </thead>
            <tbody>
              {COMPARISON_ROWS.map((row, i) => (
                <tr key={row.feature} className={i % 2 === 0 ? "bg-white/[0.015]" : ""} data-testid={`comparison-row-${i}`}>
                  <td className="px-4 py-4 text-sm font-semibold text-white">{row.feature}</td>
                  <Cell value={row.active360} highlight />
                  <Cell value={row.trainer} />
                  <Cell value={row.app} />
                </tr>
              ))}
            </tbody>
          </table>
        </ScrollReveal>
      </div>
    </section>
  );
};
